/* import * as React from 'react'; */
import React, { Component, useContext } from 'react';
import styled from 'styled-components';
import Select, { GroupTypeBase, OptionsType } from 'react-select';

const style = {
  app: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    width: '200px',
  },
  select: {},
};

export const GetSelected = (options: DdItem[], page: string | number | null): DdItem => {
  if (options && options?.length > 0) {
    if (page != null) {
      let idx = options.findIndex((e: DdItem, index: number) => {
        if (e.value == page) {
          return index;
        }
      });

      if (idx < 0) {
        idx = options.findIndex((e: DdItem, index: number) => {
          if (e.label == page) {
            return index;
          }
        });
      }

      if (idx > -1) {
        return options[idx];
      }
    }

    return options[0];
  }

  return { label: '', value: '' };
}

export interface DdItem {
  value: number | string | null,
  label: string
}

export const DropdownMenu = (props: {
  style?: any;
  onChange: any;
  selected: DdItem | null;
  options: DdItem[];
}) => {

  return (
    <DropdownWrap>
      <Select
        options={props.options}
        style={style.select}
        onChange={props.onChange}
        value={props.selected}
      />
    </DropdownWrap>
  );
};

const DropdownWrap = styled.div`
  background-color: transparent;
  width: 200px;
  //position: absolute;
  z-index: 2;
  color: #000;
  //margin-top: -45px;
`;
